module.exports = __webpack_public_path__ + "img/icon-bank.04762dfc.png";